class SwivotVideoPlayer extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.video = this.querySelector('video');
    this.toggle = this.querySelector('[data-video-toggle]');
    if (!this.video || !this.toggle) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.toggle.addEventListener('click', () => this.togglePlayback(), { signal });
    this.video.addEventListener('play', () => this.onPlay(), { signal });
    this.video.addEventListener('pause', () => this.onPause(), { signal });
    this.video.addEventListener('ended', () => this.reset(), { signal });
    this.setState('paused');
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  async togglePlayback() {
    if (this.video.paused || this.video.ended) {
      try {
        await this.video.play();
      } catch {
        this.setState('paused');
      }
    } else {
      this.video.pause();
    }
  }

  onPlay() {
    document.querySelectorAll('swivot-video-player video').forEach((video) => {
      if (video !== this.video && !video.paused) video.pause();
    });
    this.setState('playing');
  }

  onPause() {
    if (!this.video.ended) this.setState('paused');
  }

  reset() {
    this.video.pause();
    this.video.currentTime = 0;
    this.video.load();
    this.setState('paused');
  }

  setState(state) {
    this.dataset.state = state;
    const action = state === 'playing' ? 'Pause' : 'Play';
    const description = this.video?.getAttribute('aria-label') || 'setup demonstration';
    this.toggle?.setAttribute('aria-label', `${action} ${description}`);
  }
}

if (!customElements.get('swivot-video-player')) {
  customElements.define('swivot-video-player', SwivotVideoPlayer);
}
